import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-background-900 border-t border-background-800">
      <div className="mx-auto max-w-site px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-lg">
                <i className="ri-film-line"></i>
              </span>
              <span className="font-heading font-bold text-lg text-foreground-50">交换朋友的妻子</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed max-w-md">
              以电影《交换朋友的妻子》为核心的中文影视内容门户，聚合剧情介绍、演员资料、影片推荐与资讯，帮助影迷快速查阅与发现优秀的影视作品。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-foreground-100 text-base mb-4">
              <Link to="/category" className="hover:text-accent-400 transition-colors">内容导航</Link>
            </h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-foreground-400 hover:text-accent-400 transition-colors">网站首页</Link></li>
              <li><Link to="/category" className="text-foreground-400 hover:text-accent-400 transition-colors">电影分类</Link></li>
              <li><Link to="/recommendations" className="text-foreground-400 hover:text-accent-400 transition-colors">相关推荐</Link></li>
              <li><Link to="/search" className="text-foreground-400 hover:text-accent-400 transition-colors">站内搜索</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-foreground-100 text-base mb-4">
              <Link to="/about" className="hover:text-accent-400 transition-colors">关于与联系</Link>
            </h4>
            <ul className="space-y-2 text-sm text-foreground-400">
              <li><Link to="/about" className="hover:text-accent-400 transition-colors">关于本站</Link></li>
              <li>
                <a href="mailto:hello@exchange-wife.example.com" className="hover:text-accent-400 transition-colors">
                  hello@exchange-wife.example.com
                </a>
              </li>
              <li>内容合作与纠错欢迎来信</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © {year} 交换朋友的妻子 · 本站影视内容均为虚构演示数据，仅供浏览参考。
          </p>
          <p className="text-xs text-foreground-500">
            无播放、下载与支付功能
          </p>
        </div>
      </div>
    </footer>
  );
}